import { useRouter } from 'next/router'
import { useMemo } from 'react'

const useRouterQueryCollectionState = () => {
  const router = useRouter()

  const state = useMemo(() => {
    const query = { ...router.query }

    if (!query?.instock || query.instock === 'true') {
      query.instock = true
    } else {
      query.instock = false
    }

    if (query?.page === 'all') {
      query.page = 'all'
    } else if (query?.page) {
      query.page = Number(query.page)
    }

    return query
  }, [router.query])

  return state
}

export default useRouterQueryCollectionState
